var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarkerLocation = function SvgMarkerLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 4.5C17.7.6 12.4-1 8 1S2 7.8 4.1 11.6c2.2 3.8 6.7 11.8 6.7 11.8.5.9 1.9.9 2.3 0 0 0 5.4-9.5 6.7-11.8 1.3-2.2 1.3-4.8 0-7.1M12 12.9c-2 0-3.6-1.6-3.6-3.6S10 5.7 12 5.7s3.6 1.6 3.6 3.6-1.6 3.6-3.6 3.6"
  })));
};
export default SvgMarkerLocation;